<template>
	<section>
		<navigation-tab :tabs="tabs" />
		<router-view/>
	</section>
</template>

<script>
import { mapGetters } from 'vuex'
import NavigationTab from '@/components/navigation/NavigationTab'
export default {
	components: {
		NavigationTab
	},
	props: [
		'user_uid',
		'watch_id'
	],
	data() {
		return {
			profile: null,
			patient: null,
			tabs: [
				{ active: true, route: 'WatchProfile', title: this.$t('Personal Information') },
				{ active: true, route: 'WatchProfileContacts', title: this.$t('Contacts') },
				{ active: true, route: 'WatchProfileMedicalInformation', title: this.$t('Medical Information') },
				{ active: true, route: 'WatchProfileFamilyInformation', title: this.$t('Family Information') },
				{ active: true, route: 'WatchProfileSSNumbers', title: this.$t('Social Secure Numbers') },
				{ active: true, route: 'WatchProfileInsurances', title: this.$t('Insurances') },
			]
		}
	},
	computed: {
		...mapGetters({
			getPatient: 'PATIENT'
		})
	},
	beforeRouteEnter (to, from, next) {
		next(vm => {
			vm.$title(vm.$t('Watch Profile'))
		})
	},
	created () {
		this.patient = this.getPatient(parseInt(this.watch_id))
	}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/watch/profile/WatchProfile.vue